import { render, staticRenderFns } from "./DraftPriceResult.vue?vue&type=template&id=5b7f2090&"
import script from "./DraftPriceResult.vue?vue&type=script&lang=js&"
export * from "./DraftPriceResult.vue?vue&type=script&lang=js&"
import style0 from "./DraftPriceResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports